import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import bioliberty_logo from '../../assets/bioliberty-logo.svg';
import { cn } from '../../util';
import { ClinicSelectInput } from './ClinicSelectInput';
import { Nav } from './Nav';
import { ProfileMenu } from './ProfileMenu';

export const AppHeader = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <header className="border-b border-[#ffffff11] py-3 md:py-6">
      <div className="hidden h-full items-center gap-6 md:flex">
        <NavLink to="/">
          <img src={bioliberty_logo} alt="Bioliberty Logo" className="-mb-2 h-9" />
        </NavLink>
        <div className="flex-1">
          <Nav />
        </div>

        <ClinicSelectInput />
        <ProfileMenu />
      </div>

      <div className="flex items-center justify-between md:hidden">
        {isSidebarOpen ? (
          <X className="h-8 w-8 cursor-pointer md:hidden" onClick={() => setIsSidebarOpen(false)} />
        ) : (
          <Menu className="h-8 w-8 cursor-pointer md:hidden" onClick={() => setIsSidebarOpen(true)} />
        )}

        <NavLink to="/" onClick={() => setIsSidebarOpen(false)}>
          <img src={bioliberty_logo} alt="Bioliberty Logo" className="h-7 select-none" />
        </NavLink>

        <ProfileMenu />
      </div>

      <aside
        className={cn(
          'bg-primary animate-slide-in-from-left fixed top-16 left-0 z-50 h-full w-full max-w-screen',
          !isSidebarOpen && 'hidden'
        )}
      >
        <div className="flex flex-col items-center justify-center gap-8 py-2">
          <ClinicSelectInput testId="sidebar-clinics-input" />

          <Nav onNavigate={() => setIsSidebarOpen(false)} />
        </div>
      </aside>
    </header>
  );
};
